import { createFileRoute } from '@tanstack/react-router'
import { scorecardsRepository } from '@/data/adapters/api/scorecards.api'

export const Route = createFileRoute('/$orgSlug/$clientSlug/scorecards')({
  loader: ({ context: { queryClient, client } }) =>
    Promise.all([
      queryClient.ensureQueryData({
        queryKey: ['scorecards', 'weekly', client.id, 'monday'],
        queryFn: () => scorecardsRepository.getWeeklyScorecard(client.id, 'monday'),
      }),
      queryClient.ensureQueryData({
        queryKey: ['scorecards', 'monthly', client.id],
        queryFn: () => scorecardsRepository.getMonthlyScorecard(client.id),
      }),
    ]),
})
